// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3mFal","list":"BalanceDue_list__2rjYE","listRow":"BalanceDue_listRow__hkDCI","total":"BalanceDue_total__1WrKJ"};